import { render } from "./FloorListing.vue?vue&type=template&id=32460f96&ts=true"
import script from "./FloorListing.vue?vue&type=script&lang=ts"
export * from "./FloorListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__